<template>
  <div class="container">
    <div class="content">
      <div class="logo"><img class="img" src="../../assets/u115.png" /></div>
      <div class="doc-box">
        <div class="time-box">
          <div class="label">医生名称</div>
          <div class="text">金辉</div>
        </div>
        <div class="time-box">
          <div class="text-box">预约时间</div>
          <div class="text-box">{{ qData.time }}</div>
        </div>
        <div class="time-box">
          <div class="label">就诊人</div>
          <div class="text">{{ qData.name }}</div>
        </div>
        <div class="time-box">
          <div class="label">联系方式</div>
          <div class="text">{{ qData.phone }}</div>
        </div>
        <div class="time-box">
          <div class="label">核酸检测</div>
          <div class="text">￥{{ qData.cost }}</div>
        </div>
      </div>
    </div>
    <van-button color="#7bb8c8" type="primary" size="large" @click="toConfirm" :loading="refundLoading"
      :loading-type="'spinner'" loading-text="正在生成订单...">
      确认缴费
    </van-button>
    <div class="bg"></div>
  </div>
</template>

<script>
import { putHrmOrder } from '@/api/api'
export default {
  data () {
    return {
      refundLoading: false,
      qData: '',
    }
  },
  created () { },
  mounted () {
    this.qData = this.$route.query.data
  },
  methods: {
    toConfirm () {
      this.refundLoading = true;
      var value = sessionStorage.getItem("type");
      let postdata = {
        mrNo: this.qData.mrNo, //病案号
        clinicCode: this.qData.caseNo, //就诊号
        patientName: this.qData.name, //就诊人姓名
        deptCode: this.qData.deptCode, //就诊科室编码
        deptName: this.qData.deptName, //就诊科室名称
        date: this.qData.time, //就诊日期
        idNo: this.qData.idcode, //就诊人身份证号码
        patientId: this.qData.patientId, //就诊人id
        amount: this.qData.cost, //就诊金额
        // amount: '0.01', //就诊金额
        drName: this.qData.drName, //就诊医生姓名
        drCode: this.qData.drCode, //就诊人医生code
        orderType: value
      }
      putHrmOrder(postdata).then((res) => {
        this.refundLoading = false;
        if (res.code == 200) {
          this.$router.push({
            name: 'goPay',
            params: { ...res.data, preType: 'acid' },
          })
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: rgb(244, 248, 251);

  .content {
    width: 100%;
    height: 100%;
    z-index: 1;
    padding: 0 15px;
    font-size: 16px;
    position: relative;

    .toList {
      position: absolute;
      right: 10px;
      top: 10px;
      color: #fff;
      text-decoration: underline;
    }

    .logo {
      width: 100%;
      height: 148px;
      display: flex;
      justify-content: center;

      .img {
        width: 148px;
        height: 148px;
      }
    }

    .patient-box {
      width: 100%;
      background: #fff;
      padding: 10px 15px;
      display: flex;
      justify-content: space-between;

      .label {
        color: #2c2aff;
      }

      .text {
        color: #999;
        display: flex;
        align-items: center;
      }
    }

    .doc-box {
      width: 100%;
      background: #fff;
      display: flex;
      flex-direction: column;
      border-radius: 20px;
      margin-top: 20px;

      .doc-item {
        width: 100%;
        border-bottom: 1px solid rgba(228, 228, 228, 1);
        display: flex;
        align-items: center;
        padding: 10px 10px;

        .doc-headimg {
          width: 70px;
          height: 70px;

          .img {
            width: 100%;
            height: 100%;
          }
        }

        .doc-detail {
          height: 50px;
          padding-left: 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .name {
            width: 100%;
          }

          .title {
            width: 100%;

            .title-detail {
              border: 1px solid rgba(68, 203, 255, 1);
              color: #44cbff;
              font-size: 12px;
              padding: 2px 10px;
              border-radius: 3px;
              width: 60px;
              text-align: center;
            }
          }
        }
      }

      .time-box {
        width: 100%;
        display: flex;
        padding: 20px 15px;
        justify-content: space-between;

        .label {
          color: #000000;
        }

        .text {
          color: #999;
          display: flex;
          align-items: center;
        }
      }

      .text-box {
        color: red;
      }
    }
  }
}

.bg {
  width: 100%;
  height: 55vh;
  position: fixed;
  z-index: 0;
  top: -50px;
  background: rgb(123, 184, 187);
  border-radius: 50px;
}

.van-button--large {
  width: calc(100vw - 30px);
  height: 50px;
  margin-left: 15px;
  margin-top: 20px;
  border-radius: 10px;
}
</style>
